export default {"src":"/_next/static/media/drgn.beb8afa9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};